<template>
  <section>
    <div class="container content-padding">

      <div class="row justify-content-md-center">
        <div class="col-6">
          <a href="#" @click.prevent="backToLogin" style="color: #00BCD4;">
            <i class="fas fa-2x fa-arrow-left"></i>
          </a>
        </div>
      </div>
      <div class="row text-center mt-3">
        <div class="col-12">
          <img src="/static/img/logo.png" alt="logo" class="img-fluid" style="height: 85px;">
        </div>
      </div>
      <div class="row  justify-content-md-center mt-5">
        <div class="col-md-6 text-center">
          <h3>Partner OTP Verification</h3>
          <p>Enter OTP sent to <span style="text-decoration: underline;">{{ emailSentOtp }}</span></p>

          <form @submit.prevent="submitOtp" class="digit-group form-otp" data-group-name="digits" data-autosubmit="true" autocomplete="off">
            <input type="text" maxlength="1" id="digit-1" name="digit-1" data-next="digit-2" required/>
            <input type="text" maxlength="1" id="digit-2" name="digit-2" data-next="digit-3" required data-previous="digit-1"/>
            <input type="text" maxlength="1" id="digit-3" name="digit-3" data-next="digit-4" required data-previous="digit-2"/>
            <input type="text" maxlength="1" id="digit-4" name="digit-4" data-next="digit-5" required data-previous="digit-3"/>
            <input type="text" maxlength="1" id="digit-5" name="digit-5" data-next="digit-6" required data-previous="digit-4"/>
            <input type="text" maxlength="1" id="digit-6" name="digit-6" data-next="digit-7" required data-previous="digit-5"/>

            <div class="row mt-5">
              <div class="col-12">
                <p>Don't receive the OTP ?
                  <a href="#" style="color: #00BCD4;" @click.prevent="resendOTP" :class="{'disabled-resend' : isDisabledResendOtp}">
                    RESEND OTP
                  </a>
                </p>
                <p v-if="timeLeftResendOTP < 30 && timeLeftResendOTP > 0" class="text-muted" style="font-size: 14px;">
                  Can be resend in {{ timeLeftResendOTP }} seconds.
                </p>
              </div>
            </div>

            <div class="row" style="margin-top: 5rem;">
              <div class="col-12">
                <button class="button-large button-block -cyan" id="submit-otp" :disabled="isSubmittingOtp" type="submit">{{ verifyTextButton }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SendPartnerOTP',
  props: {
    username: {
      default: ''
    },
    password: {
      default: ''
    },
    emailSentOtp: {
      default: ''
    }
  },
  data () {
    return {
      isSubmittingOtp: false,
      isDisabledResendOtp: false,
      timeLeftResendOTP: 30
    }
  },
  computed: {
    verifyTextButton () {
      return this.isSubmittingOtp ? 'Verifying...' : 'Verify and Process'
    }
  },
  methods: {
    ...mapActions('authPartner', {
      LOGIN_PARTNER: 'LOGIN',
      GET_PARTNER: 'GET_PARTNER'
    }),
    backToLogin () {
      this.$emit('clearData')
    },
    setTimerResendOTP () {
      this.timeLeftResendOTP = 30
      const countdownTimer = setInterval(() => {
        this.timeLeftResendOTP--

        if (this.timeLeftResendOTP <= 0) {
          this.isDisabledResendOtp = false
          clearInterval(countdownTimer)
        }
      }, 1000)
    },
    async resendOTP () {
      // ส่ง otp ใหม่ และ ตั้งเวลา 30 วินาทีเพื่อให้ส่งได้อีกครั้ง
      this.isDisabledResendOtp = true
      this.setTimerResendOTP()
      await this.LOGIN_PARTNER({ username: this.username, password: this.password, need_otp: true })
    },
    async submitOtp () {
      let otp = ''
      window.$('input[name^=digit]').each(function (idx, elem) {
        otp += window.$(elem).val()
      })
      if (otp.length !== 6) {
        this.$swal({ text: 'ผิดพลาดกรุณากรอก OTP ให้ครบ 6 หลัก', type: 'error' })
        return
      }

      this.isSubmittingOtp = true
      try {
        const partnerData = {
          username: this.username,
          password: this.password,
          otp: otp.trim()
        }

        const dataPartnerLogin = await this.LOGIN_PARTNER(partnerData)
        if (!dataPartnerLogin.error) {
          await this.GET_PARTNER(dataPartnerLogin)
          this.$router.push({ path: `/partners/grab/report`, replace: true })
        }
      } catch (err) {
        // ถ้ากรอกไม่ถูกต้องจะ focus input ตัวสุดท้าย
        window.$('input#digit-6').focus().select()
        this.$swal({ title: 'ไม่สามารถเข้าสู่ระบบได้', text: 'รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง', type: 'error' })
      }
      this.isSubmittingOtp = false
    },
    initEventInputOTP () {
      // ตั้งค่า input เลื่อน focus เวลาพิมพ์
      window.$('form.digit-group').find('input').each(function () {
        window.$(this).attr('maxlength', 1)
        window.$(this).on('keyup', function (e) {
          let parent = window.$(window.$(this).parent())

          // กด Backspace หรือ ลูกศรซ้าย
          if (e.keyCode === 8 || e.keyCode === 37) {
            let prev = parent.find('input#' + window.$(this).data('previous'))
            if (prev.length) {
              window.$(prev).select()
            }
          } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
            // กด ตัวเลข หรือ ลูกศรขวา
            let next = parent.find('input#' + window.$(this).data('next'))
            if (next.length) {
              window.$(next).select()
            } else {
              // ให้เช็คว่าตั้ง auto submit ไว้รึเปล่าที่ attr data
              if (parent.data('autosubmit')) {
                window.$('button#submit-otp').click()
              }
            }
          } else {
            // ถ้าพิมพ์มาไม่ใช่ตัวเลข จะเป็นค่าว่าง
            window.$(e.currentTarget).val('')
          }
        })
      })
    }
  },
  mounted () {
    this.initEventInputOTP()
  }
}
</script>

<style scoped lang="scss">

form.form-otp {

  input {
    border: 0;
    border-bottom: 2px solid #C0C0C0;
    outline: 0;
    color: #111111;
    width: 37px;
    padding: 0 5px;
    margin-right: 10px;
    text-align: center;
    font-size: 3em;
    cursor: pointer;
    will-change: border;
    transition: border .3s ease-in-out;
    -webkit-appearance: none;
    -moz-appearance: textfield;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    -moz-appearance: textfield;
    appearance: none;
    margin: 0;
  }

  input:focus {
    border: 0;
    border-bottom: 2px solid #ff6200;
  }

  input:disabled {
    background: #fff;
  }

  input:last-child {
    margin-right: 0;
  }

  .paintOrangeLine {
    border: 0;
    border-bottom: 2px solid #ff6200;
  }

  a.disabled-resend {
    pointer-events: none;
    cursor: default;
    opacity: .3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partner/SendPartnerOTP.vue